import * as React from "react";
import { createRoot } from "react-dom/client";
import App from "./components/App";
import { FluentProvider, webLightTheme } from "@fluentui/react-components";
import ChatBot from "./components/ChatBot";

/* global document, Office, module, require, HTMLElement */

const title = "Digital Protocol LLM Helper";

const rootElement: HTMLElement | null = document.getElementById("container");
const root = rootElement ? createRoot(rootElement) : undefined;

/* Render application after Office initializes */
Office.onReady(() => {
  root?.render(
    <ChatBot />
  );
});

if ((module as any).hot) {
  (module as any).hot.accept("./components/ChatBot", () => {
    const NextApp = require("./components/ChatBot").default;
    root?.render(NextApp);
  });
}
